/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { NavigationClient, NavigationOptions } from '@azure/msal-browser';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { NavigateFunction } from 'react-router-dom';

class CombinedNavigationClient extends NavigationClient {
  private readonly navigate: NavigateFunction;

  constructor(navigate: NavigateFunction) {
    super();
    this.navigate = navigate;
  }

  async navigateInternal(url: string, options: NavigationOptions): Promise<boolean> {
    const relativePath = url.replace(window.location.origin, '');
    if (options.noHistory) {
      this.navigate(relativePath, { replace: true });
    } else {
      this.navigate(relativePath);
    }
    return false;
  }

  async navigateExternal(url: string, options: NavigationOptions): Promise<boolean> {
    if (Capacitor.isNativePlatform()) {
      // Do not launch the logout URL.
      if (url.includes('logout')) {
        return false;
      } else {
        console.log('launching Browser', url);
        await Browser.open({
          url: url,
          toolbarColor: '#004733',
        });
        return true;
      }
    } else {
      return this.defaultWebHandlingLogic(url, options);
    }
  }

  defaultWebHandlingLogic(url: string, options: NavigationOptions): Promise<boolean> {
    if (options.noHistory) {
      window.location.replace(url);
    } else {
      window.location.assign(url);
    }
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(true);
      }, options.timeout);
    });
  }
}

export const instantiateCombinedClient = (navigate: NavigateFunction): CombinedNavigationClient => {
  return new CombinedNavigationClient(navigate);
};
